module.exports = __webpack_public_path__ + "static/media/img-1.0c1071da.jpg";